
import { useState, useEffect } from 'react'
import { Button} from '@mui/material'
import DoneIcon from '@mui/icons-material/Done'
import { useAuth } from '../../contexts/AuthContext'
import { usePost } from '../../apis/ApiRequests'
import CustomSnackBar from '../../components/alert/CustomSnackBar'
import CustomConfirm from '../../components/confirm/CustomConfirm'
import Header from '../../components/Header'
import TitleBar from '../../components/uiParts/TitleBar'
import CustomOutlinedInput from '../../components/input/CustomOutlinedInput'
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd'

const UserInfo = () => {
    
    const { authInfo,          setAuthInfo          } = useAuth()
    const [ searchCount,       setSearchCount       ] = useState(0)
    const [ code,              setCode              ] = useState('')
    const [ openConfirm,       setOpenConfirm       ] = useState(false)
    const [ openSnackBarTrue,  setOpenSnackBarTrue  ] = useState(false)
    const [ openSnackBarFalse, setOpenSnackBarFalse ] = useState(false)
    const [ openRequire,       setOpenRequire       ] = useState(false)
    const [ requireMessage,    setRequireMessage    ] = useState('')
    const [ name,              setName              ] = useState('')
    const [ password,          setPassword          ] = useState('')
    const [ password_1,        setPassword_1        ] = useState('')
    const [ password_2,        setPassword_2        ] = useState('')
    const [ password_3,        setPassword_3        ] = useState('')

	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
    // initialize - セッション情報を取得
	//-----------------------------------------------
    const facilityCode = authInfo.facilityCode
    const facilityName = authInfo.facilityName
    const userId       = authInfo.userId
    const userName     = authInfo.userName
    const authority    = authInfo.authority
    const traderCode   = authInfo.traderCode
    const trader       = authInfo.trader
    
	//===============================================
	// API
	//===============================================
	//-----------------------------------------------
    // API - データの検索
	//-----------------------------------------------
    const { response : getData_Res, loading : getData_Loading, post : getData_Post } = usePost()
    const getData = async () => {
        const postData = {
            'className'    : 'mch.models.masta.User',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'code'         : userId
        }
        await getData_Post(postData)
    }
	//-----------------------------------------------
    // API - データの登録
	//-----------------------------------------------
    const { response : setData_Res, loading : setData_Loading, post:setData_Post } = usePost()
    const setData = async (activeFlag) => {
        const postData = {
            'className'    : 'mch.models.masta.User',
            'methodName'   : 'setData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'activeFlag'   : activeFlag,
            'userId'       : userId,
            'name'         : name,
            'password'     : password_2,
            'authority'    : authority,
            'traderCode'   : traderCode
        }
        await setData_Post(postData)
    }
	//===============================================
	// useEffect
	//===============================================
	//-----------------------------------------------
    // useEffect - ロード時の設定
	//-----------------------------------------------
    useEffect(() => {
        setSearchCount(searchCount+1)
    },[])
	//-----------------------------------------------
    // useEffect - APIコール（検索処理）
	//-----------------------------------------------
    useEffect(() => {
        if (getData_Res) {
            setName(getData_Res.name)
            setPassword(getData_Res.password)
        }
    }, [getData_Res])
    console.log(getData_Res)
	//-----------------------------------------------
    // useEffect - APIコール（登録処理）
	//-----------------------------------------------
    useEffect(() => {
        if (setData_Res) {
            handleCloseConfirm()
            handleClickSnackBarTrue()
            setSearchCount(searchCount+1)
        }
    }, [setData_Res])
	//-----------------------------------------------
    // useEffect - 検索処理
	//-----------------------------------------------
    useEffect(() => {
        getData()
    }, [searchCount])

	//===============================================
	// eventHandler
	//===============================================
	//-----------------------------------------------
    // eventHandler - 登録ボタン
	//-----------------------------------------------
    const handleClick_Register = (activeFlag) => {
        const requireStatus = checkedRequire() // 必須項目をチェックする
        console.log(requireStatus)
        if (requireStatus) {
            setData(activeFlag)
        } else {
            handleClickSnackBarRequire()
        }
    }
	//===============================================
	// Function
	//===============================================
	//-----------------------------------------------
	// Function - 必須項目をチェックする
	//-----------------------------------------------
    const checkedRequire = () => {
        const errorFields = [];
    
        if (password != password_1) {
            setRequireMessage('登録済みのパスワードと現在のパスワードが一致しません')
            return false;  // エラーがある場合は false を返します
        }
        if (password_2 != password_3) {
            setRequireMessage('新しいパスワードと再入力したパスワードが一致しません')
            return false;  // エラーがある場合は false を返します
        }
        
        return true  // エラーがない場合は true を返します
    }
	//===============================================
	// UI Message
	//===============================================
    // コンファームの表示
    const handleOpenConfirm = () => { setOpenConfirm(true) }
    
    // コンファームを閉じる
    const handleCloseConfirm = () => { setOpenConfirm(false) }
    
    // スナックバー(必須チェック)を表示
    const handleClickSnackBarRequire = () => { setOpenRequire(true) }
    
	// スナックバー(必須チェック)を閉じる
    const handleCloseSnackBarRequire = (event, reason) => {
        if (reason === 'clickaway') { return } setOpenRequire(false)
    }
	// スナックバー(正常)を表示
    const handleClickSnackBarTrue = () => { setOpenSnackBarTrue(true) }
    
	// スナックバー(正常)を閉じる
    const handleCloseSnackBarTrue = (event, reason) => {
        if (reason === 'clickaway') { return } setOpenSnackBarTrue(false)
    }
	// スナックバー(異常)を表示
    const handleClickSnackBarFalse = () => { setOpenSnackBarFalse(true) }
    
	// スナックバー(異常)を閉じる
    const handleCloseSnackBarFalse = (event, reason) => {
        if (reason === 'clickaway') { return } setOpenSnackBarFalse(false)
    }
    //===============================================
    // Css
    //===============================================
	//===============================================
	// JSXのレンダー
	//===============================================
    return (
        <>
            <Header loginInfo="on" backButton="on" backPage="/home" />
            <div className='userInfo bodyContens'>
                <TitleBar title="パスワード変更" />
                <div style={{padding:'0px 20px 0px 20px', fontSize:'18px'}}>
                    <div style={{float:'left', padding:'10px'}}>
                        <AssignmentIndIcon style={{ fontSize: 70,color:'#305496' }} />
                    </div>
                    <div style={{float:'left', padding:'15px'}}>
                        <div>ID : { userId }</div>
                        <div style={{color:'#03B7D2', fontSize:'20px', fontWeight:'bold'}}>{ userName } / { trader }</div>
                        </div>
                    <div style={{clear:'both'}}></div>
                </div>
                <div style={{padding:'20px'}}>
                    <div>
                        <CustomOutlinedInput
                            id       = "userInfo_password_1"
                            type     = "password"
                            label    = "現在のパスワードを入力"
                            value    = { password_1 }
                            width    = "100%"
                            onChange = {(e) => setPassword_1(e.target.value)}
                        />
                    </div>
                    <div style={{marginTop:'10px'}}>
                        <CustomOutlinedInput
                            id       = "userInfo_password_2"
                            type     = "password"
                            label    = "新しいパスワードを入力"
                            value    = { password_2 }
                            width    = "100%"
                            onChange = {(e) => setPassword_2(e.target.value)}
                        />
                    </div>
                    <div style={{marginTop:'10px'}}>
                        <CustomOutlinedInput
                            id       = "userInfo_password_3"
                            type     = "password"
                            label    = "新しいパスワードを再入力"
                            value    = { password_3 }
                            width    = "100%"
                            onChange = {(e) => setPassword_3(e.target.value)}
                        />
                    </div>
                    <div style={{marginTop:'10px'}}>
                        <Button
                            color     = "primary"
                            size      = "large"
                            variant   = "contained"
                            sx        = {{width:'100%'}}
                            onClick   = { () => handleClick_Register(1) }
                            startIcon = {<DoneIcon />}
                        >{'更新'}
                        </Button>
                    </div>
                </div>
                <CustomSnackBar
                    open            = {openSnackBarTrue}
                    onClose         = {() => handleCloseSnackBarTrue()}
                    severity        = "success"
                    backgroundColor = "#2e8b57"
                    message         = "登録しました"
                />
                <CustomSnackBar
                    open            = {openSnackBarFalse}
                    onClose         = {() => handleCloseSnackBarFalse()}
                    severity        = "error"
                    backgroundColor = "#db7093"
                    message         = "登録に失敗しました"
                />
                <CustomSnackBar
                    open            = {openRequire}
                    onClose         = {() => handleCloseSnackBarRequire()}
                    severity        = "error"
                    backgroundColor = "#db7093"
                    message         = {requireMessage}
                />
                <CustomConfirm
                    open      = {openConfirm}
                    onClose   = {() => handleCloseConfirm()}
                    onClickNG = {() => handleCloseConfirm()}
                    onClickOK = {() => handleClick_Register(0)}
                    message   = "指定データの削除を行います。よろしいですか？"
                />
            </div>
        </>
    )
}
export default UserInfo

  